import React from "react";
import Pagination from "react-js-pagination";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

const CustomPagination = (props) => {
  const { pageSize, totalCount, totalPagesFromData, pageNumberParam } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const onPageChange = (pageNumber) => {
    if (searchParams.size > 1) {
      const currentUrl = location.pathname;
      const pageNum = `&page=${pageNumber}`;
      const firstSearch = location.search.split("&")[0];
      const newURL = encodeURI(currentUrl + firstSearch + pageNum);
      navigate(newURL);
    } else {
      const currentUrl = location.pathname;
      const pageNum = `?page=${pageNumber}`;
      const newURL = encodeURI(currentUrl + pageNum);
      navigate(newURL);
    }
  };

  const shouldRenderPagination = totalCount > pageSize;

  if (!shouldRenderPagination) {
    return null;
  }

  return (
    <Pagination
      activePage={Number(pageNumberParam)}
      itemsCountPerPage={pageSize}
      totalItemsCount={totalCount}
      onChange={onPageChange}
      pageRangeDisplayed={5}
      nextPageText={"Next"}
      prevPageText={"Prev"}
      firstPageText={"First"}
      lastPageText={"Last"}
      itemClass="page-item"
      linkClass="page-link"
    />
  );
};

export default CustomPagination;
